// src/components/titlebar/components/WindowControls.tsx

import React from "react"
import AppTooltip from "@shared/components/tooltip/AppTooltip"
import { tooltipTitleByKey } from "@shared/components/tooltip/tooltipRegistry"

import { Minimize as MinimizeIcon, CropSquare as MaximizeIcon, Close as CloseIcon } from "@mui/icons-material"
import { WindowControlsContainer, ControlButton } from "../styles/titleBarStyles"
import type { WindowControlsProps } from "../types/titleBarTypes"

const WindowControls: React.FC<WindowControlsProps> = ({ onMinimize, onMaximize, onClose }) => {
  return (
    <WindowControlsContainer>
      <AppTooltip
        title={tooltipTitleByKey("common.minimize")}
        placement="bottom"
        disableInteractive
        slotProps={{ popper: { sx: { pointerEvents: "none" } } }}
      >
        <ControlButton controlType="minimize" onClick={onMinimize}>
          <MinimizeIcon />
        </ControlButton>
      </AppTooltip>
      <AppTooltip
        title={tooltipTitleByKey("common.maximize")}
        placement="bottom"
        disableInteractive
        slotProps={{ popper: { sx: { pointerEvents: "none" } } }}
      >
        <ControlButton controlType="maximize" onClick={onMaximize}>
          <MaximizeIcon />
        </ControlButton>
      </AppTooltip>
      <AppTooltip
        title={tooltipTitleByKey("common.closeWindow")}
        placement="bottom"
        disableInteractive
        slotProps={{ popper: { sx: { pointerEvents: "none" } } }}
      >
        <ControlButton controlType="close" onClick={onClose}>
          <CloseIcon />
        </ControlButton>
      </AppTooltip>
    </WindowControlsContainer>
  )
}

export default WindowControls
